// WHITELABEL-1 layer 4 — root-mapped boot (the shell half of "serve the
// bellforge workspace at app.bellforge.eu"). Ticket: tickets/opus.md
// WHITELABEL-1. Server half (layers 1+3) shipped in `server 4fbe1ba0` and is
// consumed here, not re-derived — see functions/customDomainHost.js's
// header for the exact boundary.
//
// Deliberately a ROOT-level shell file (sibling to index.js/app.js/
// config.js), NOT inside functions/ — this package's owning charter splits
// "Shell" (index.js, app.js, config.js, routes.js, …) from "Frank-discovered
// folders only: components/, pages/, functions/, methods/, snippets/, …".
// This file's whole job is a bare MODULE-TOP-LEVEL side effect (see below),
// which is exactly the FA514 "module-side-effect bridge" pattern frank
// strips when it serializes a functions/*.js file's exports to JSON. Living
// at the package root instead keeps it in the same bucket as index.js's own
// existing top-level side effects (`const _redirecting = redirectIfUnauthed(
// …)`, the top-level `void import('smbls')`, the boot IIFE) — literal
// Parcel-bundled JS, never round-tripped through frank's JSON schema.
//
// On a host-resolved boot (custom domain, not a `/w/<org>` URL path) `/` IS
// the workspace: no Scheme-A `/w/<org>` prefix anywhere, ever. The cleanest
// way to guarantee that is to make sure Scheme-A NEVER ACTIVATES on this
// host at all, rather than adding a second "strip the prefix on the way out"
// mechanism — MWT (multi-workspace-tabs, shared/functions/mwtFlag.js) is the
// ONE thing that emits/consumes the `/w/<org>` prefix (mwtRouter.js
// `planMwtNav` returns null — a transparent pass-through — whenever
// `isMwtEnabled()` is false), and it already ships a supported, documented
// per-origin opt-out: `localStorage.setItem('mwt', 'off')`. Because a custom
// domain is a SEPARATE browser origin from my.symbols.app, writing that key
// here can never bleed into (or be bled into by) the platform host's own
// localStorage — this is purely additive to my.symbols.app/w/<org>, which
// this file never touches (isCustomDomainHost() is false there).
//
// MUST run before the first `isMwtEnabled()` call anywhere in the boot
// (its resolved value is cached for the life of the tab — mwtFlag.js
// `globalThis.__mwtFlagCache`). That is the ONLY reason this is its own
// file: index.js imports it as the very first import statement, ahead of
// the `@symbo-ls/workspace-shared` import whose module graph is what
// actually calls `isMwtEnabled()` (via context.js → mwtRouter registration)
// during bootShell/create(). ES module imports execute in the order their
// import declarations appear when there's no cross-dependency forcing
// otherwise, so this side effect lands first. Self-contained (no sibling
// imports) is deliberate too — the earlier this can execute, the safer.
//
// An explicit per-load `?mwt=1`/`?mwt=on` still wins for THAT tab
// (mwtFlag.js checks the query string before localStorage), so a debug
// session can still force MWT on over this default without fighting it —
// this only sets the DEFAULT a fresh load with no override resolves to.
import { isCustomDomainHost } from './functions/customDomainHost.js'

try {
  if (
    typeof window !== 'undefined' &&
    isCustomDomainHost() &&
    window.localStorage?.getItem('mwt') !== 'off'
  ) {
    window.localStorage.setItem('mwt', 'off')
  }
} catch (_) {
  // localStorage may throw in sandboxed contexts — worst case MWT stays on
  // and a host-resolved boot could compose a `/w/<org>` URL; never let this
  // module crash the boot over it.
}
